/**
 * Навигация раздела «Библиотеки»: список, «Все референсы», корзина — со счётчиками.
 *
 * Счётчики берут те же запросы, что экраны (`libraryKeys.list`/`basket`), поэтому
 * лишнего трафика нет, а после действия на экране число обновляется само.
 */
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";

import { libraryKeys, loadBasket, loadLibraries } from "@/lib/library";

type Current = "list" | "all" | "basket" | "library";

export function LibNav({ current }: { current: Current }) {
  const list = useQuery({ queryKey: libraryKeys.list, queryFn: loadLibraries, staleTime: 30_000 });
  const basket = useQuery({ queryKey: libraryKeys.basket, queryFn: loadBasket, staleTime: 30_000 });

  const libs = list.data ? list.data.groups.reduce((n, g) => n + g.libs.length, 0) : null;
  const links: { key: Exclude<Current, "library">; to: string; text: string; count: number | null }[] = [
    { key: "list", to: "/lib", text: "Библиотеки", count: libs },
    { key: "all", to: "/lib/all", text: "Все референсы", count: list.data?.items_total ?? null },
    { key: "basket", to: "/lib/basket", text: "Корзина", count: basket.data?.items.length ?? null },
  ];

  return (
    <nav className="flex items-center gap-4 text-sm">
      {links.map((l) => (
        <Link key={l.key} to={l.to} className={current === l.key ? "text-fg" : "text-fg-muted hover:text-fg"}>
          {l.text}
          {l.count !== null && <span className="tnum"> {l.count}</span>}
        </Link>
      ))}
    </nav>
  );
}
